import React, { useState, useEffect, Fragment } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { getProjectEconomicFrameworksOverviewWp } from '@lib/api';
import { formatToDecimals } from 'lib/helpers/formatting';
import { OETrans } from 'components/translation/OETrans';

const itemOverviewNames = {
	totalEligibleCosts: { label: 'Total eligible costs' },
	maximumEuContribution: { label: 'Maximum EU contribution' },
	requestedEuContribution: { label: 'Requested EU contribution' },
	totalEstimatedIncome: { label: 'Total estimated income' },
	ikaaContribution: { label: 'IKAA' },
	indirectCosts: { label: 'Indirect costs' },
	maxGrantAmount: { label: 'Max grant amount' },
};

const EconomicFrameworkOverview = ({ projectId, itemNames, isRefresh, setIsRefresh }) => {
	const [totalsOverview, setTotalsOverview] = useState({});
	const [overview, setOverview] = useState([]);

	const groupByCompany = (data) => {
		return Object.keys(data).map((key) => {
			const company = data[key];

			return {
				...company,
				expenseItems: company.expenseItems
					? company.expenseItems.map((item) => ({
							id: item.id,
							name: item.name,
							amount: item.amount,
						}))
					: [],
			};
		});
	};

	useEffect(() => {
		if (projectId || isRefresh) {
			getProjectEconomicFrameworksOverviewWp(projectId).then((retrievedOverview) => {
				if (retrievedOverview.success) {
					const { totals } = retrievedOverview.data;
					setTotalsOverview(totals);

					setOverview(groupByCompany(retrievedOverview.data.companies));
               setIsRefresh(false);
				}
			});
		}
	}, [isRefresh, projectId, setIsRefresh]);

	return (
		<>
			{overview ? (
				<>
					<Row className="row d-flex align-items-center mt-3 mb-4">
						<Col className="col-4">
							<h5 className="title-box">
								<OETrans code="common.overview" fallback={'Overview'} />
							</h5>
						</Col>
					</Row>

					<Row className="gy-3 gx-4">
						{Object.keys(totalsOverview).map((key) => (
							<Col key={key} xs={12} sm={6} md={4} lg={2} className='mt-0' style={{ minWidth: 'fit-content' }}>
								<Card className="card-econframe-overview border-0 shadow-none">
									<Card.Body className="d-flex flex-column justify-content-center text-center">
										<Card.Title>{itemOverviewNames[key].label}</Card.Title>
										<Card.Text>{formatToDecimals(totalsOverview[key] ?? 0) + ' €'}</Card.Text>
									</Card.Body>
								</Card>
							</Col>
						))}
					</Row>
				</>
			) : null}
		</>
	);
};
export default EconomicFrameworkOverview;
